<template>
    <div class="container">
        <div class="title-name">
            {{device.AreaName}} <span style="font-weight: 400;vertical-align: 1px;color: #CCCCCC;margin:0 5px"> |</span> 
            {{device.device_name}}
            <span style="color:rgba(245, 170, 0, 1);margin-left:16rem">
                <!-- 运行电压下降，补偿效果较差 -->
            </span>
        </div>
        <div class="body">
            <div class="left">
                <div class="left-item" style="color:rgba(104, 216, 106, 1)">
                    <div>投</div>
                    <div>
                        <span v-if="switching_tou=='--'" class="grey">{{switching_tou}}</span>
                        <span v-else>{{switching_tou}}</span>
                    </div>
                </div>
                <div class="left-item" style="color:rgba(253, 66, 56, 1)">
                    <div>切</div>
                    <div>
                        <span v-if="switching_qie=='--'" class="grey">{{switching_qie}}</span>
                        <span v-else>{{switching_qie}}</span>
                    </div>
                </div>
            </div>
            <div class="center">
                <div class="title">功率因数</div>
                <div class="center-value" :style="color()">
                    {{pf}}<span v-if="icon()!='负'">&nbsp;&nbsp;{{icon()}}</span>
                </div>
                <div class="center-desc">
                    <div class="center-desc" v-if="icon()=='优'">功率因数是指交流电路有功功率对视在功率的比值。用户电器设备在一定电压和功率下，该值越高效益越好，发电设备越能充分利用。</div>
                    <div class="center-desc" v-if="icon()=='良'">功率因数是指交流电路有功功率对视在功率的比值。用户电器设备在一定电压和功率下，该值越高效益越好，发电设备越能充分利用。</div>
                    <div class="center-desc" v-if="icon()=='差'">功率因数过低可以造成设备利用率降低，线路损耗增加，供电局功率因数罚款（利率电费）。</div>
                    <div class="center-desc" v-if="icon()=='负'">暂无负荷电流，请确认有负荷电流后再观察功率因数是否正常，正常情况下功率因数一般为-1~1，当无负荷电流时可能会导致功率因数偏移。</div>
                </div>
            </div>
            <div class="right">
                <div class="item">
                    <div class="right-item">
                        <div class="title">总电流谐波</div>
                        <div class="right-item-font">
                            <span style="color:rgb(104, 216, 106)" v-if="$store.getters.projectId==19">
                                {{ harmonics }}
                            </span>
                            <span style="color:rgb(104, 216, 106)" v-else>
                                <i v-if="$store.getters.mqttVal(device.subLoopUrl + '/THD_I') == undefined" class="grey">-- </i>
                                <i v-else>{{floatFormat($store.getters.mqttVal(device.subLoopUrl + '/THD_I'),2)}} %</i>
                            </span>
                        </div>
                    </div>
                    <div class="right-item">
                        <div class="title">总电压谐波</div>
                        <div class="right-item-font">
                            <span style="color:rgb(104, 216, 106)" v-if="$store.getters.projectId==19">
                                {{ voltage }}
                            </span>
                            <span style="color:rgb(104, 216, 106)" v-else>
                                <i v-if="$store.getters.mqttVal(device.subLoopUrl + '/THD_U') == undefined" class="grey">--</i>
                                <i v-else>{{floatFormat($store.getters.mqttVal(device.subLoopUrl + '/THD_U'),2)}} %</i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="info" v-if="fow > 4" style="color:#F5AA00 "><img src="@/assets/img/warning.png" alt="" />电流电压超出允许范围</div>
                <div class="info" v-else-if="$store.getters.mqttVal(device.subLoopUrl + '/THD_U')!=undefined" >当前谐波在允许范围内</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        floatFormat
    } from "../../../util/MathUtil"

    export default {
        name: "CapacitanceItems",
        props: ['device','AreaName'],
        data() {
            return {
                switching: ['Status_a', 'Status_b', 'Status_c', 'Status_d', 'Status_e']
            }
        },
        created() {
            if( this.$store.state.project.currentProject.projectId == 5 ){
                this.switching = ['Status_a', 'Status_b', 'Status_c', 'Status_d', 'Status_e', 'Status_f', 'Status_g', 'Status_h', 'Status_i', 'Status_j']
            }else{
                this.switching = ['Status_a', 'Status_b', 'Status_c', 'Status_d', 'Status_e']
            }
        },
        computed: {
            harmonics(){
                let Ia = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD_Ia'))
                let Ib = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD_Ib'))
                let Ic = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD_Ic'))
                let PA = Ia + Ib + Ic
                if (isNaN(PA) || PA == 0) {
                    return '--'
                } else {
                    return parseFloat(Number((PA/3).toFixed(2)))
                }
            },
            voltage(){
                let Ia = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD_Ua'))
                let Ib = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD_Ub'))
                let Ic = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD_Uc'))
                let PA = Ia + Ib + Ic
                if (isNaN(PA) || PA == 0) {
                    return '--'
                } else {
                    return parseFloat(Number((PA/3).toFixed(2)))
                }
            },
            pf() {
                if (this.$store.getters.projectId == 4) {
                    // 有功
                    let Pa = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/Pa'))
                    let Pb = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/Pb'))
                    let Pc = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/Pc'))
                    let P = Pa + Pb + Pc
                    // 视在
                    let PAa = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/PAa'))
                    let PAb = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/PAb'))
                    let PAc = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/PAc'))
                    let PA = PAa + PAb + PAc
                    if (isNaN(P) || isNaN(PA) || PA == 0) {
                        return '--'
                    } else {
                        return parseFloat(Number((P / PA).toFixed(2)))
                    }
                }if (this.$store.getters.projectId == 18) {
                    let PAa = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/PFa'))
                    let PAb = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/PFb'))
                    let PAc = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/PFc'))
                    let PA = PAa + PAb + PAc
                    console.log(PAa,PAb,PAc)
                    if (isNaN(PA) || PA == 0) {
                        return '--'
                    } else {
                        return parseFloat(Number(PA/3).toFixed(2))
                    }
                } 
                // else if(this.$store.getters.projectId == 19) {
                //     let Ia = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD-Ia'))
                //     let Ib = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD-Ib'))
                //     let Ic = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD-Ic'))
                //     let Ua = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD-Ua'))
                //     let Ub = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD-Ub'))
                //     let Uc = Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD-Uc'))
                //     let PA = PAa + PAb + PAc
                //     console.log(PAa,PAb,PAc)
                //     if (isNaN(PA) || PA == 0) {
                //         return '--'
                //     } else {
                //         return parseFloat(Number(PA/3).toFixed(2))
                //     }
                // } 
                else {
                    return this.$store.getters.mqttVal(this.device.subLoopUrl + '/PF') == undefined ? '--' :
                        Number(this.$store.getters.mqttVal(this.device.subLoopUrl + '/PF')).toFixed(2)
                }

                // return this.$store.getters.mqttVal(this.device.subLoopUrl + '/PF') == undefined ? '--' :
                //     this.$store.getters.mqttVal(this.device.subLoopUrl + '/PF')
            },
            switching_tou() {
                let num = 0,
                    status = 0
                // if(this.$store.state.project.currentProject.projectId == 19){
                //     this.switching = ['Status_a', 'Status_b', 'Status_c', 'Status_d', 'Status_e', 'Status_f', 'Status_g', 'Status_h', 'Status_i', 'Status_j']
                //     if(this.device.device_details!=undefined){
                //         let detail = JSON.parse(this.device.device_details)['电气']['投切数量']
                //         if(detail){
                //             this.switching = this.switching.splice(0,detail)
                //         }
                //     }
                // }
                this.switching.forEach((item) => {
                    // console.log(this.$store.getters.mqttVal(this.device.subLoopUrl + '/' + item),"ss")
                    if (this.$store.getters.mqttVal(this.device.subLoopUrl + '/' + item) == undefined) {
                        status += 1
                    } else if (this.$store.getters.mqttVal(this.device.subLoopUrl + '/' + item) == 1) {
                        num += 1
                    }
                })
                return status == 5 ? '--' : num
            },
            switching_qie() {
                let num = 0,
                    status = 0
                // if(this.$store.state.project.currentProject.projectId == 19){
                    if(JSON.parse(this.device.device_details)['电气']['投切数量']!=undefined){
                        let switching = ['Status_a', 'Status_b', 'Status_c', 'Status_d', 'Status_e', 'Status_f', 'Status_g', 'Status_h', 'Status_i', 'Status_j']
                        let detail = JSON.parse(this.device.device_details)['电气']['投切数量']
                        if(detail){
                            switching = switching.splice(0,detail)
                            return detail
                        }
                    }else{
                        this.switching.forEach((item) => {
                            if (this.$store.getters.mqttVal(this.device.subLoopUrl + '/' + item) == undefined) {
                                status += 1
                            } else if (this.$store.getters.mqttVal(this.device.subLoopUrl + '/' + item) == 0) {
                                num += 1
                            }
                        })
                        return status == 5 ? '--' : num
                    }
            },
            fow() {
                if (this.$store.getters.mqttVal(this.device.subLoopUrl + '/THD_U') > 4) {
                    return 5
                } else {
                    return 1
                }
            },
        },
        methods: {
            floatFormat,
            color() {
                if (!this.pf) {
                    return "color:#FD4238";
                } else if (this.pf > 0.9) {
                    return "color:#68D86A";
                } else if (this.pf > 0.5) {
                    return "color:#F5AA00";
                } else if (this.pf <= 0.5){
                    return "color:#FD4238";
                }
            },
            icon() {
                if (!this.pf) {
                    return "";
                } else if (this.pf > 0.9) {
                    return "优";
                } else if (this.pf > 0.5) {
                    return "良";
                } else if (this.pf >0&&this.pf <= 0.5) {
                    return "差";
                } else if(this.pf <0){
                    return '负'
                }
            }
        }
    };
</script>

<style lang="less" scoped>
    .container {
        width: 100%;
        // .h(285);
        // margin-top: 80/108vh;
        // padding: 20rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 10px;
        .title-name{
            font-size: 18rem;
            font-weight: bold;
            color: #333333;
            line-height: 50rem
        }
        .title {
            font-size: 18rem;
            font-weight: bold;
            color: #333333;
            // line-height: 30rem
        }

        .body {
            .h(204);
            
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .left {
                .w(200);
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .left-item {
                    width: 100%;
                    .h(98);
                    background: rgba(0, 43, 102, 0.04);
                    font-size: 30rem;
                    font-weight: bold;
                    font-family: Source Han Sans CN;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    div {
                        width: 50%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }

            .center {
                .w(467);
                height: 100%;
                background: rgba(0, 43, 102, 0.04);
                padding: 28rem 48rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;

                .center-value {
                    font-size: 36rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                }

                .center-desc {
                    font-size: 16rem;
                    color: #666666;
                    height: 50rem
                }
            }

            .right {
                .w(467);
                height: 100%;
                background: rgba(0, 43, 102, 0.04);
                display: flex;
                flex-direction: column;
                .item{
                    display: flex;
                    flex-direction: row;
                }
                .info{
                    
                    font-size: 28rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #68D86A;
                    padding-left: 63rem;
                    img{
                        vertical-align: -6px;
                        width: 28px;
                        margin-right: 5px;
                    }
                }
                .right-item {
                    width: 50%;
                    height: 100%;
                    padding: 28rem 0 0rem 63rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;

                    span {
                        color: rgba(13, 148, 255, 1);
                    }

                    .right-item-font {
                        font-size: 36rem;
                        font-weight: bold;
                        line-height: 80rem;
                    }
                }
            }
        }
    }
</style>